module.exports = __webpack_public_path__ + "img/reader.45ea235a.png";